/*
 * ॐ नमः शिवाय
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms 
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this 
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and 
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useTheme } from "../theme/ThemeContext";
import GradientBar from "../components/common/GradientBar";
import EditTableForm from "../components/applications/EditTableForm";
import APIHelper from "../api/APIHelper";
import envConfig from "../config/envConfig";
import ProgressBarDialog from "../components/common/ProgressBar";

const apiHelper = new APIHelper({
    apiUrl: envConfig.backendApiUrl,
    tokenUrl: envConfig.backendTokenUrl,
    clientId: envConfig.clientKey,
    clientSecret: envConfig.clientSecret,
});

export default function EditTablePage() {
    const { theme } = useTheme();
    const navigate = useNavigate();
    const { id, tableName } = useParams();

    const [exists, setExists] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function verify() {
            setLoading(true);
            try {
                const resp = await apiHelper.apiCall(`/arcee/application/table/details/`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        application_id: id,
                        table_name: tableName,
                    }),
                });

                if (resp.ok) {
                    setExists(true);
                } else {
                    setExists(false);
                }
            } catch {
                setExists(false);
            } finally {
                setLoading(false);
            }
        }

        verify();
    }, [id, tableName]);

    if (loading) {
        return (
            <div style={{ maxWidth: 800, margin: "52px auto", textAlign: "center" }}>
                <ProgressBarDialog open={true} text_message="Loading Table..." />
            </div>
        );
    }

    if (!exists) {
        return (
            <div style={{ maxWidth: 800, margin: "52px auto" }}>
                <GradientBar height={10} />
                <div
                    style={{
                        padding: 20,
                        marginTop: 20,
                        background: "#fff",
                        borderRadius: theme.cardRadius,
                        boxShadow: "0 4px 24px rgba(65,70,150,0.13)",
                    }}
                >
                    <h2 style={{ color: theme.primary }}>Table Not Found</h2>
                    <p style={{ color: "#555" }}>
                        The table <b>{tableName}</b> does not exist or you do not have access.
                    </p>
                    <button
                        className="btn btn-secondary"
                        onClick={() => navigate(-1)}
                        style={{
                            marginTop: 10,
                            background: theme.secondary,
                            color: "#fff",
                        }}
                    >
                        Go Back
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div style={{ maxWidth: 800, margin: "52px auto" }}>
            <EditTableForm
                applicationId={parseInt(id, 10)}
                tableName={tableName}
            />
        </div>
    );
}
